import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-duda-site-admin-sso-button',
  templateUrl: './DudaSiteAdminSSOButton.component.html'
})
export class DudaSiteAdminSSOButtonComponent {
  @Input() showSiteInfo: boolean;

  isLoading = false;
  ssoUrlForAdmin: string = null;

  constructor() { }

  signOnWithSsoUrlForAdmin() {
    if (this.ssoUrlForAdmin) {
      window.open(this.ssoUrlForAdmin);
    } 
    else {
      toastr.error("Unable to retrieve single sign-on URL.");
    }
  }
}